import type { ItEmailPublic } from '@accounts/shared';

/**
 * WHAT IS WAITING ON IT (spec rows 15 and 18): the SENT emails that still have open items,
 * oldest sent first, and their open and overdue item totals. The Queue's Waiting on IT lane
 * draws these and the Overview's Waiting on IT tile counts them, so the tile can never
 * promise more than the lane holds. Overdue is the server's flag on the email.
 */
export interface WaitingOnIt {
  emails: ItEmailPublic[];
  open: number;
  overdue: number;
}

export function waitingOnIt(emails: readonly ItEmailPublic[]): WaitingOnIt {
  const waiting = emails
    .filter((email) => email.status === 'sent' && email.openItemCount > 0)
    .sort((a, b) => Date.parse(a.sentAt ?? a.createdAt) - Date.parse(b.sentAt ?? b.createdAt));
  return {
    emails: waiting,
    open: waiting.reduce((sum, email) => sum + email.openItemCount, 0),
    overdue: waiting
      .filter((email) => email.overdue)
      .reduce((sum, email) => sum + email.openItemCount, 0),
  };
}

/** The Queue's `?type=` value for its Waiting on IT lane (the Overview's tile links here). */
export const WAITING_ON_IT_LANE = 'it';
